import { getFullTranslations } from './util';

export const itTranslationMessages = getFullTranslations('it');
